import { Injectable } from '@angular/core';
import { CanActivate, Router, CanActivateChild } from '@angular/router';
import { UrlConstants } from '@app/core/constants/url.constants';
import { AuthService } from '../services/auth/auth.service';
import { LocalStorageService } from '../services/storage/storage.service';
import { AppConstants } from '../constants/app.constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private router: Router,
    private storageService: LocalStorageService
  ) {}

  canActivate() {
    if (this.authService.isAuthenticated()) {
      this.storageService.remove(AppConstants.localStorageAutoLogin);
      return true;
    }

    this.router.navigate([UrlConstants.loginUrl]);
    return false;
  }

  canActivateChild() {
    if (this.authService.isAuthenticated()) {
      return true;
    }

    this.router.navigate([UrlConstants.loginUrl]);
    return false;
  }
}
